import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { GuidedTourActions } from '../+state/guided-tour.actions';
import { guidedTourFeature } from '../+state/guided-tour.reducer';

@Injectable({ providedIn: 'root' })
export class GuidedTourFacade {
  public loaded$ = this.store.select(guidedTourFeature.selectLoaded);
  public loading$ = this.store.select(guidedTourFeature.selectLoading);
  public showNotification$ = this.store.select(guidedTourFeature.selectShowNotification);
  public error$ = this.store.select(guidedTourFeature.selectError);

  constructor(private readonly store: Store) {}

  public loadCheckNotifications() {
    this.store.dispatch(GuidedTourActions.loadGuidedTourNotifications());
  }

  public dismissNotification() {
    this.store.dispatch(GuidedTourActions.dismissGuidedTourNotification());
  }
}
